import { formatCurrency } from "../../../../helpers";
import { Bulb, EditPencil, House } from "../../../../icons";
import DonutChart from "./DonutChart";
interface FAQ {
  question: string;
  answer: [
    {
      type: string;
      data: string[];
    },
  ];
}
interface ResultsProps {
  setEditing: any;
  basic_salary: number;
  dearness_allowance: number;
  commissions: number;
  hra_received: number;
  rent_paid: number;
  lives_in_metro: "Yes" | "No";
  limit1: number;
  limit2: number;
  limit3: number;
  exempted_hra: number;
  taxable_hra: number;
  faq?: FAQ[];
}
const Results = ({
  exempted_hra,
  taxable_hra,
  limit1,
  setEditing,
  limit2,
  lives_in_metro,
  limit3,
}: ResultsProps) => {
  return (
    <div className="grid grid-cols-2 bg-white p-6 rounded-xl">
      {/* donut chart */}
      <div className="flex flex-col justify-center items-center ">
        <DonutChart
          data={[
            {
              color: "#d1c6ff",
              percentage: parseFloat(
                (taxable_hra / (taxable_hra + exempted_hra)).toFixed(2),
              ),
            },
            {
              color: "#661eff",
              percentage: parseFloat(
                (exempted_hra / (taxable_hra + exempted_hra)).toFixed(2),
              ),
            },
          ]}
        />
        {/* Legend */}
        <div className="flex mt-2 items-center justify-center font-normal">
          <div className="bg-[#d1c6ff] w-3 h-3"></div>
          <p className="ml-1 text-sm">Taxable HRA</p>
          <div className="bg-[#661eff] w-3 h-3 ml-5"></div>
          <p className="ml-1 text-sm">Claimable HRA</p>
        </div>
        <div className="flex flex-col items-center justify-center mt-5">
          <p className="text-lg font-semibold">Claimable HRA</p>
          <p className="mt-1 font-normal text-base">
            This is the amount you can claim for HRA
          </p>
          <p className="text-[#661eff] text-3xl font-bold mt-4">
            {formatCurrency(exempted_hra, "INR")}
          </p>
        </div>
      </div>

      {/* Calculations */}
      <div className="flex flex-col">
        <div className="p-4 rounded-lg border border-[#ebebeb]">
          <p className="font-semibold text-base">See how it is calculated</p>
          <div className="flex flex-col p-4 divide-y-2 border rounded-lg mt-2">
            <div className="flex justify-between text-sm font-normal py-2">
              <p>Actual HRA received</p>
              <p className="font-semibold">{formatCurrency(limit1, "INR")}</p>
            </div>
            <div className="flex justify-between text-sm font-normal py-2">
              <p>{`${lives_in_metro === "Yes" ? "50%" : "40%"} of basic salary`}</p>
              <p className="font-semibold">{formatCurrency(limit2, "INR")}</p>
            </div>
            <div className="flex justify-between text-sm font-normal py-2">
              <p>{"Rent paid in excess of 10% of salary"}</p>
              <p className="font-semibold">{formatCurrency(limit3, "INR")}</p>
            </div>
          </div>
          <div className="px-2 rounded-lg mt-2 gap-2 py-4 bg-[#faf5e5] border border-[#ecd996] flex items-center justify-start">
            <House />
            <p className="text-sm font-normal text-wrap">
              Least of the three will be claimable HRA
            </p>
          </div>
          <div className="rounded-lg p-4 mt-4 divide-y-2 bg-primary-300 border border-[#ebebeb]">
            <div className="flex  justify-between text-sm font-semibold py-2">
              <p>Claimable HRA</p>
              <p className="">{formatCurrency(exempted_hra, "INR")}</p>
            </div>
            <div className="flex  justify-between text-sm font-semibold py-2">
              <p>Taxable HRA</p>
              <p className="">{formatCurrency(taxable_hra, "INR")}</p>
            </div>
          </div>
        </div>
        <div
          className="flex justify-between items-center my-4 p-4 rounded-lg border border-[#ebebeb] hover:cursor-pointer"
          onClick={() => {
            setEditing(true);
          }}
        >
          <p className="text-base font-semibold">Edit Details</p>
          <EditPencil width={20} height={20} fillColor="#000" />
        </div>
        <div className="flex items-center rounded-lg bg-[#dbf9d5] border border-[#6ee755] p-4 ">
          <Bulb width={72} height={72} />
          <p className="text-base font-normal ml-4 text-wrap">
            {"If you don’t receive HRA, you can now claim up to "}
            <span className="font-semibold">
              ₹60,000 deduction under Section 80GG.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Results;
